import { render } from "./NotificationToasts.vue?vue&type=template&id=58272a3c"
import script from "./NotificationToasts.vue?vue&type=script&lang=js"
export * from "./NotificationToasts.vue?vue&type=script&lang=js"

import "./NotificationToasts.vue?vue&type=style&index=0&id=58272a3c&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__